// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fraxure: PokeData = {
  "id": 611,
  "name": "fraxure",
  "height": 10,
  "weight": 360,
  "base_experience": 144,
  "types": [
    PokeType.DRAGON
  ],
  "api_moves": [
    "scratch",
    "guillotine",
    "swords-dance",
    "leer",
    "bite",
    "dragon-rage",
    "focus-energy",
    "slash",
    "scary-face",
    "outrage",
    "false-swipe",
    "crunch",
    "taunt",
    "dragon-claw",
    "dragon-dance",
    "assurance",
    "dragon-pulse",
    "giga-impact",
    "dual-chop",
    "laser-focus",
    "breaking-swipe"
  ],
  "moves": [
    "scratch",
    "leer",
    "bite",
    "scary-face",
    "outrage",
    "crunch",
    "dragon-claw",
    "dragon-dance",
    "dragon-pulse",
    "great-roar",
    "dragon-breath",
    "draco-meteor",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 309,
    "item": null,
    "species": [
      {
        "name": "axew",
        "order": 611,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "fraxure",
        "order": 612,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 610,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "haxorus",
        "order": 613,
        "types": [
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 611,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63,
    "speed": 67,
    "ability_power": 117
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
